import { render } from "./MdlEliminacionFamilia.vue?vue&type=template&id=31300804&scoped=true"
import script from "./MdlEliminacionFamilia.vue?vue&type=script&lang=js"
export * from "./MdlEliminacionFamilia.vue?vue&type=script&lang=js"

import "./MdlEliminacionFamilia.vue?vue&type=style&index=0&id=31300804&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31300804"]])

export default __exports__